import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-rate',
  templateUrl: './rate.component.html',
  styleUrls: ['./rate.component.scss']
})
export class RateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
